<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col" @click="() => { doneAt = !doneAt; changePage(page); }">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        {{doneAt ? 'Erledigte' : 'Nicht erledigte'}} Aufgaben
                    </h3>
                </div>
                <div class="col text-right">
                    <!--- <base-button type="primary" size="sm" v-on:click="$router.push('/locations/create')">hinzufügen</base-button> --->
                    <base-button size="sm" type="secondary" @click="changePage(page)" icon="fas fa-sync-alt"></base-button>
                    <!--- todo: tasktemplate oder task aus template oder einzelne aufgabe ---> <!----<addtask></addtask> --->
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th v-if="isAdmin">Organisation</th>
                    <TableHeadFilter title="Standort" :has-filter="true" :has-sort="false" v-model="tableOptions.filter.location"
                                     :dropdownList="locations" filter-type="dropdown" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Mitarbeiter" :has-filter="true" :has-sort="false" v-model="tableOptions.filter.profile"
                                     :dropdownList="profiles" filter-type="dropdown" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Aufgabe" :has-filter="true" v-model="tableOptions.filter.type" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Antwort" :has-filter="true" v-model="tableOptions.filter.answer" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Hinweis" :has-filter="true" v-model="tableOptions.filter.comment" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Erledigt" :has-filter="true" :has-sort="true" v-model="tableOptions.dateFilter.doneAt" filter-type="date" @input="changePage(1)"><TableSortControl v-model="tableOptions.sort.doneAt" @input="changePage(1)"></TableSortControl></TableHeadFilter>
                    <th></th>
                </template>

                <template slot-scope="{row,index}">
                    <td v-if="isAdmin">
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>{{$store.getters['customer/showCustomerByIRI'](row.user.customer).name}}</div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" >
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>{{row.user.firstname}} {{row.user.lastname}} <br> {{row.location.name}}</div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" class="px-0">
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>
                            <span v-if="!editable.includes(row.id) || isLoading">{{(row.profile !== null) ? $store.getters['profiles/showProfileByIRI'](row.profile).name : '-'}}</span>
                            <select v-else v-model="row.profile"
                                    class="mb-1 custom-select form-control">
                                <option v-for="profile in $store.getters['profiles/showProfilesByUser'](row.user.id)" :key="profile.id" :value="profile['@id']">{{ profile.name }}
                                </option>
                            </select>
                        </div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" >
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>{{row.type}}</div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" class="px-1" style="white-space: normal;">
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>
                            <span v-if="!editable.includes(row.id) || isLoading" >{{ row.answer }}</span>
                            <select v-else v-model="row.answer"
                                    class="mb-1 custom-select form-control">
                                <option v-for="(answer,index) in row.possibleAnswers" :key="index" :value="answer.value">{{ answer.value }}
                                </option>
                            </select>
                        </div>
                    </td >
                    <td v-on:dblclick="editable.push(row.id)" class="px-0" style="white-space: normal;">
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>
                        <span v-if="!editable.includes(row.id) || isLoading" v-b-tooltip.hover :title="row.comment">{{(typeof row.comment !== 'undefined') ? shortenString(row.comment) : '' }}</span>
                        <base-input v-else v-model="row.comment" class="mb-1" input-classes="form-control"></base-input>
                    </div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" >
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>
                      <span v-if="!editable.includes(row.id) || isLoading">{{(typeof row.doneAt !== 'undefined' && row.doneAt !== null ) ? $options.filters.formatDateShort(row.doneAt) : 'noch nicht erledigt'   }} <br> <span class="text-muted">{{row.doAt | formatDateShort }}</span></span>
                        <base-input v-else
                                    required
                                    class="col-form-label mb-0"
                                    placeholder="Datum&Uhrzeit der Durchführung">

                            <flat-pickr slot-scope="{focus, blur}"
                                        @on-open="focus"
                                        @on-close="blur"
                                        ref="pickr"
                                        :config="config"
                                        class="form-control mb-1 datepicker"
                                        v-model="row.doneAt">
                            </flat-pickr></base-input>
                    </div>
                    </td>
                    <td class="text-right" :key="tick">
                        <div v-if="computedIsLoading" class="loading-button"> </div><div v-else><template>
                        <div v-if="!row.delete">
                            <base-button v-if="!editable.includes(row.id)" v-on:click="editable.push(row.id)" icon="fas fa-pencil-alt" type="secondary" icon-only
                                         title="Quickedit"></base-button>
                            <div v-else>
                                <base-button v-on:click="editable.splice(editable.indexOf(row.id),1)" v-if="!isLoading" icon="fa fa-ban" type="secondary" icon-only
                                             title="abbrechen"></base-button>
                                <base-button :key="tick+'bcn1'" v-on:click="editTask(row)" :disabled="currentlyLoading.includes(row.id)" :icon="(currentlyLoading.includes(row.id)) ? 'fas fa-circle-notch fa-spin' : 'fas fa-save'" type="primary" icon-only
                                             title="speichern"></base-button></div>
                        </div>
                        <base-button v-if="!row.delete && !$store.getters['authentication/isService']" type="secondary" icon="far fa-trash-alt" icon-only v-on:click="deleteConfirmation(index)"></base-button>
                        <div v-if="row.delete" style="margin-top: 1rem;"><span  class="text-danger">Sicher? <i class="fas fa-trash-alt"></i></span><br>
                            <base-button :key="tick+'bcn2'" v-if="row.delete" size="sm" :disabled="currentlyLoading.includes(row.id)" :icon="(currentlyLoading.includes(row.id)) ? 'fas fa-circle-notch fa-spin' : 'fas fa-check'" type="danger" v-on:click="deleteTask(row)">Ja</base-button>
                            <base-button v-if="row.delete" size="sm" type="info" icon="fas fa-times" v-on:click="deleteConfirmation(index)">Nein</base-button>
                        </div>
                    </template></div>

                    </td>
                </template>
            </base-table>
        </div>

        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>

    </div>
</template>

<script>
    import moment from 'moment-timezone';
    import FlatPickr from "vue-flatpickr-component/src/component";
    import "flatpickr/dist/flatpickr.css";
    import { German } from "flatpickr/dist/l10n/de.js";
    import TableHeadFilter from "@/components/TableHeadFilter";
    import TableSortControl from "@/components/TableSortControl";
    //import Addtask from "@/views/Tasks/addtask";

    export default {
        name: "list",
        props: {
            type: {
                type: String
            },
            title: String
        },
        components:{TableSortControl, TableHeadFilter, FlatPickr},
        data() {
            return {
                doneAt:true,
                tableOptions: {
                    filter: {
                        location: null,
                        profile: null,
                        type: null,
                        answer: null,
                        comment: null,

                    },
                    dateFilter: {
                        doneAt: null
                    },
                    sort:{
                        doneAt: 'DESC'
                    }},
                editable: [],
                currentlyLoading: [],
                tableData: [
                    {
                        id: 0,
                        profile: {
                            name: ''
                        },
                        user: {
                            firstname: '',
                            lastname: '',
                            customer: {
                                name: ''
                            }
                        },
                        location: {
                            name: ''
                        },
                        answer: null,
                        doneAt: new Date(),
                        isPublic:false,
                        possibleAnswers:[],
                        doAt: null,
                        type:'',
                        isActive:true,
                        isAutocomplete:false,
                        stat: '',
                        comment: ''
                    }
                ],
                config: {
                    dateFormat: 'YYYY-MM-DDTHH:mm:ssZ',
                    altFormat: 'DD.MM.YYYY HH:mm',
                    enableTime: true,
                    time_24hr: true,
                    altInput: true,
                    allowInput: true,
                    locale: German,
                    parseDate(dateString, format) {
                        let timezonedDate = new moment.tz(dateString, format, 'Europe/Berlin');

                        return new Date(
                            timezonedDate.year(),
                            timezonedDate.month(),
                            timezonedDate.date(),
                            timezonedDate.hour(),
                            timezonedDate.minute(),
                            timezonedDate.second()
                        );
                    },
                    formatDate(date, format) {
                        let time;
                        if (format ==='YYYY-MM-DDTHH:mm:ssZ'){
                            time = moment.tz([
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                                date.getHours(),
                                date.getMinutes(),
                                date.getSeconds()
                            ], 'Europe/Berlin').utc().format();
                        } else {
                            time = moment.tz([
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                                date.getHours(),
                                date.getMinutes(),
                                date.getSeconds()
                            ], 'Europe/Berlin').locale('en-GB').format(format);
                        }

                        return time;
                    }
                },
                totalitems: 0,
                page: 1,
                isLoading: false,
                tick: 1
            }
        },
        created() {
          this.changePage(this.page);
            if (this.$store.getters['profiles/showActiveProfile'] === null && !this.$store.getters['profiles/isReady']) this.$store.dispatch('profiles/getProfiles');
            if (!this.$store.getters['customer/isReady'])  this.$store.dispatch('customer/getCustomerCollection');
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            profiles() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return (!this.$store.getters['profiles/isReady']) ? [] : this.$store.getters['profiles/showProfiles'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            },
            locations() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return (!this.$store.getters['location/isReady']) ? [] : this.$store.getters['location/showLocationCollection'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            },
            computedIsLoading() {
                return this.$store.getters['actions/isLoading'] || this.$store.getters['profiles/isLoading'] || this.$store.getters['customer/isLoading'] || this.isLoading
            }
        },
        methods: {
            shortenString(string) {
              return (string.length > 38) ? string.slice(0,38)+" ..." : string;
            },
            setLoading(val) {
                this.isLoading = val;
                this.tick++;
            },
            changePage(page) {
                this.setLoading(true)
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.tableData.forEach(item => {
                            item.profile = (typeof item.profile !== "undefined") ? item.profile['@id'] : null;
                        });
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.setLoading(false)
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/tasks?`+ this.getUrlExtension(this.tableOptions.filter,this.tableOptions.sort,this.tableOptions.dateFilter) +`page=` + page + `&exists%5BdoneAt%5D=` + this.doneAt, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            },
            editTask(data) {
                return new Promise(() => {
                    this.currentlyLoading.push(data.id);
                    this.tick++;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = JSON.parse(JSON.stringify(data));
                    delete senddata.user;
                    delete senddata.location;
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/tasks/`+data.id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.$store.dispatch('alert/success', 'Aufgabe (ID: '+response.id+') wurde editiert.');
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.editable.splice(this.editable.indexOf(data.id),1);
                                this.tick++;
                            },
                            error => {
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.tick++;
                                this.$store.dispatch('alert/error', error);
                            });
                });
            },
            deleteTask(data) {
                return new Promise((resolve, reject) => {
                    this.currentlyLoading.push(data.id);
                    this.tick++;
                    //this.deleteConfirmation(this.tableData.indexOf(data));
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'DELETE',
                        headers: header,
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/tasks/`+data.id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.changePage(this.page);
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.tick++;
                            },
                            error => {
                                reject(error);
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.tick++;
                            });
                });
            },
            deleteConfirmation(index) {
                if(typeof this.tableData[index].delete === "undefined") {
                    this.tableData[index].delete = false;
                }
                this.tableData[index].delete = !this.tableData[index].delete;
                this.tick++;
            }
        }
    }
</script>

<style scoped>


</style>